var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.411,
    height: 9.665,
    viewBox: "0 0 16.411 9.665",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-view-100424",
    transform: "translate(-0.002 -92.35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8620",
    "data-name": "Path 8620",
    d: "M8.171,102.014c4.384,0,8.025-4.28,8.025-4.28a.836.836,0,0,0,.009-1.116s-3.461-4.269-8-4.269-8,4.269-8,4.269a.845.845,0,0,0,0,1.12s3.57,4.276,7.954,4.276Zm.038-1.421a3.411,3.411,0,1,0-3.4-3.411A3.406,3.406,0,0,0,8.208,100.593Zm0-1.895A1.516,1.516,0,1,0,6.7,97.182,1.514,1.514,0,0,0,8.208,98.7Z",
    transform: "translate(0)",
    fill: "#4EB6EE",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.ee793d15ba7918df4a30aa08c9df2ae7.svg";
export { ForwardRef as ReactComponent };